import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { StatsView } from '../components/views'
import { ViewChartDataModalContent } from '../components/modalContent/viewChartDataContent'
import Modal from '../components/reusable/modal'
import { DataView } from '../components/views/dataBreakdownView'
import pageStyles from '../globals/pages.module.scss'
import { Page, PageHeader } from '../ui'
function IntroducerStats() {
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)
    const [overviewData, setOverviewData] = useState<any>()
    const [modalChartData, setModalChartData] = useState<any>()
    const [modalState, setModalState] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalDate, setModalDate] = useState('')
    const [lenderClaims, setLenderClaims] = useState([])
    const [buttonText, setButtonText] = useState('Sort Volume')

    useEffect(() => {
        if (modalChartData != null) {
            setModalState(true)
        }
    }, [modalChartData])

    useEffect(() => {
        if (!dataReady && !loading) {
            setLoading(true)
            getData()
        }
    }, [dataReady, loading])

    const getData = async () => {
        Loading.circle('Loading...')
        try {
            const apiResponse = await api({ url: '/introducer-stats' })

            // const apiResponse = await api({ url: '/introducer-stats' })
            const data = apiResponse.data
            // console.log('SYSTEM OVERVIEW DATA: ', data)

            setOverviewData(data)
            setLenderClaims(data.claimsByLender.lenderClaimsByChronology)
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                window.location.href = getLoginUrl()
            }
        }
    }

    const prepChartData = (data: any) => {
        setModalDate(data.date)
        setModalChartData(data.dataResults)
        setModalTitle(data.title)
        // setModalState(false)
    }

    const toggleModal = () => {
        setModalChartData(null)
        setModalTitle('')
        setModalState(false)
    }

    const resortLenderData = () => {
        if (buttonText == 'Sort A-Z') {
        }
        setLenderClaims(
            buttonText == 'Sort A-Z'
                ? overviewData.claimsByLender.lenderClaimsByChronology
                : overviewData.claimsByLender.lenderClaimsByVolume
        )
        setButtonText(buttonText == 'Sort A-Z' ? 'Sort Volume' : 'Sort A-Z')
    }

    return (
        <div className={pageStyles.introducerStats}>
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="PCP Introducers" title={'Sentinel Introducer Analytics'} />
                    <div>
                        {dataReady ? (
                            <StatsView
                                stats={overviewData.stats}
                                chartData={overviewData?.chartData}
                                dataGroup={overviewData.group}
                                handleDataModal={prepChartData}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                    {dataReady ? (
                        <>
                            <div className={pageStyles.lenderSort}>
                                <button onClick={() => resortLenderData()}>{buttonText}</button>
                            </div>
                            <DataView
                                dataViewTitle="Lender Claim Volume"
                                dataType="IntroducerLenderClaimVolume"
                                data={lenderClaims}
                            />
                        </>
                    ) : (
                        <></>
                    )}
                </Page>
            </MainView>{' '}
            <Modal modalState={modalState} previewModalAction={toggleModal}>
                <ViewChartDataModalContent
                    chartData={modalChartData}
                    closeModal={toggleModal}
                    chartTitle={modalTitle}
                    chartDate={modalDate}
                />
            </Modal>
        </div>
    )
}

export default IntroducerStats
